import React, { useState, useEffect } from 'react';
import useSWR from 'swr';
import './HaberAkisi.css';

const fetcher = url => {
    const token = localStorage.getItem('token');

    return fetch(url, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(res => {
        if (!res.ok) {
            const error = new Error('Yetkilendirme hatası veya sunucuya ulaşılamadı.');
            error.info = res.statusText;
            error.status = res.status;
            throw error;
        }
        return res.json();
    });
};


function HaberAkisi() {
    const { data: tumHaberler, error } = useSWR('/api/haberler', fetcher, { refreshInterval: 900000 });
    const [aktifIndex, setAktifIndex] = useState(0);
    const [animasyonDurumu, setAnimasyonDurumu] = useState('giris');

    useEffect(() => {
        if (!tumHaberler || tumHaberler.length === 0) return;
        const interval = setInterval(() => {
            setAnimasyonDurumu('cikis');
            setTimeout(() => {
                setAktifIndex(prevIndex => (prevIndex + 1) % tumHaberler.length);
                setAnimasyonDurumu('giris');
            }, 500);
        }, 5000);
        return () => clearInterval(interval);
    }, [tumHaberler]);

    if (error) return <div style={{color: 'white', fontSize: '12px'}}>Haberler yüklenemedi.</div>;
    if (!tumHaberler || tumHaberler.length === 0) return <div></div>;

    // O anki aktif haberi ve linkini alalım
    const aktifHaber = tumHaberler[aktifIndex];

    return (
        <div className="haber-akisi-container">
            {/* --- DEĞİŞİKLİK BURADA: Artık bir <a> etiketi kullanıyoruz --- */}
            <a 
                href={aktifHaber.link} 
                target="_blank" // Haberi yeni bir sekmede açar
                rel="noopener noreferrer" // Güvenlik için
                key={aktifIndex} 
                className={`haber-item ${animasyonDurumu}`}
                style={{color: 'white', textDecoration: 'none'}} // Linkin alt çizgisini kaldırır
            >
                {aktifHaber.title}
            </a>
        </div>
    );
}

export default HaberAkisi;